import styled from "styled-components";

export const ContentContainer = styled.div`
    width: 100%;
    max-width: 100%;
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    padding-left: ${props => props?.removeLeftMargins ? 'unset' : '84px'};
    padding-right: 16px;
    background: #FAFAFA;
    overflow-x: hidden;
    box-sizing: border-box;
    @media print {
        padding-left: 0px !important;
        padding-right: 0px !important;
    }
    @media (min-width: 768px){
        padding-left: ${props => props?.removeLeftMargins ? 'unset' : '96px'};
        padding-right: 24px;
    }
`
